if (!customElements.get('tf-collection-layout')) {
  customElements.define('tf-collection-layout', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }

    init() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.desktop = matchMedia('(min-width: 990px)');
      this.button = this.querySelector('.facets-button-show');
      this.wrapper = this.querySelector('#FacetsWrapperDesktop');
      this.form = this.querySelector('.facets--desktop');
      this.sort = this.querySelector('#SortBy');
      this.radios = [...this.querySelectorAll('[data-tf-mobile-sort]')];
      this.addEventListener('click', event => {
        if (!this.desktop.matches || !event.target.closest('.facets-button-show')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.dataset.sidebar = this.dataset.sidebar === 'open' ? 'closed' : 'open';
        this.update();
      }, { ...options, capture: true });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-tf-mobile-sort]')) this.syncSort(event.target.value);
        else if (event.target === this.sort || event.target.id === 'FacetSortForm') this.syncSort(this.sort.value);
        if (event.target.matches('.facets__item > input[type="checkbox"]')) {
          event.target.nextElementSibling?.setAttribute('aria-checked', String(event.target.checked));
        }
      }, { ...options, capture: true });
      this.addEventListener('keydown', event => {
        const label = event.target.closest('label.facet-checkbox[role="checkbox"]');
        if (!label || ![' ', 'Enter'].includes(event.key)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const input = document.getElementById(label.htmlFor);
        if (input && !input.disabled) input.click();
      }, { ...options, capture: true });
      this.desktop.addEventListener('change', () => {
        if (this.querySelector('.facets__container.active')) this.form?.closeFacets(new Event('close'));
        this.update();
      }, options);
      window.addEventListener('popstate', () => this.syncSort(new URLSearchParams(location.search).get('sort_by') || this.dataset.defaultSort), options);
      this.update();
    }

    syncSort(value) {
      if (this.sort) this.sort.value = value;
      this.radios.forEach(radio => { radio.checked = radio.value === value; });
      const choice = this.radios.find(radio => radio.value === value);
      const label = this.querySelector('.facet-sort-select__current');
      if (choice && label) label.textContent = choice.parentElement.textContent.trim();
      this.querySelectorAll('.facet-sort-select__option').forEach(option => option.classList.toggle('facet-sort-select__option--selected', option.dataset.value === value));
    }

    update() {
      const desktop = this.desktop.matches;
      if (this.sort) this.sort.disabled = !desktop && this.radios.length > 0;
      this.radios.forEach(radio => { radio.disabled = desktop; });
      if (!this.button || !this.wrapper) return;
      const expanded = desktop && this.dataset.sidebar === 'open';
      const label = expanded ? this.dataset.hideLabel : this.dataset.showLabel;
      const buttonLabel = this.button.querySelector('.button__label');
      if (buttonLabel) { buttonLabel.textContent = label; buttonLabel.dataset.label = label; }
      this.button.setAttribute('aria-label', label);
      this.button.setAttribute('aria-controls', this.wrapper.id);
      if (desktop) this.button.setAttribute('aria-expanded', String(expanded));
      else this.button.removeAttribute('aria-expanded');
      this.wrapper.setAttribute('role', desktop ? 'complementary' : 'dialog');
      this.wrapper.setAttribute('aria-label', this.dataset.showLabel);
      if (desktop) this.wrapper.removeAttribute('aria-modal');
      else this.wrapper.setAttribute('aria-modal', 'true');
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
    }
  });
}
